import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'SaleType/Find', method: 'POST', body: filter, token: token })
}
